import {Modal} from "antd";
import "./ConfirmationModal.scss";

export interface SelectScheduleModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export function SelectScheduleModal({isVisible, onClose}: SelectScheduleModalProps) {
  return (
    <Modal
      className={"confirmation-modal clean"}
      visible={isVisible}
      onCancel={() => onClose()}
    >
      <header>
        <h2>Select a schedule to start adding events.</h2>
      </header>
    </Modal>
  );
}
